import { loginUser, setSession } from 'actions'
import LoginWithGoogleButton from 'features/Login/Google'
import LoginWithMicrosoftButton from 'features/Login/Microsoft'
import { useDispatch } from 'react-redux'
import LocalUserService from 'services/localUserService'

import styles from './LoginButtons.module.scss'

const userService = new LocalUserService()

const LoginButtons = ({ setGoogleLoginError, setMicrosoftLoginError }) => {
  const dispatch = useDispatch()

  function loginToDashboard(data) {
    if (!data?.sessionId || !data?.user) {
      const error = new Error('Invalid login response')
      handleMicrosoftLoginError(error)
      return
    }

    userService.setCurrentUserInfo(data)
    userService.storeLastUser(data.user)

    dispatch(setSession(data.sessionId))
    dispatch(loginUser(data.user, data.userToken, data.userId, data.sessionId))
  }

  function handleGoogleLoginError(error) {
    const errorString = error.toString()

    const clearErrorString = errorString
      .replace('Error: ', '')
      .replace('Error: ', '')
      .replace(' from login/login-google', '')

    if (clearErrorString === 'Login with Google not allowed') {
      setGoogleLoginError('Your dashboard configuration does not allow login with Google')
    } else if (clearErrorString === 'Google account is not suitable for login') {
      setGoogleLoginError(
        'Your Google account is not suitable for login. Personal accounts are not allowed.'
      )
    } else if (clearErrorString === 'User not found') {
      setGoogleLoginError('A user with this Google account was not found in the system')
    } else {
      setGoogleLoginError(
        `An error occurred while logging in with Google: ${errorString}`
      )
    }
  }

  function handleMicrosoftLoginError(error) {
    const errorString = error.toString()

    const clearErrorString = errorString
      .replace('Error: ', '')
      .replace('Error: ', '')
      .replace(' from login/login-microsoft', '')

    if (clearErrorString === 'Login with Microsoft not allowed') {
      setMicrosoftLoginError(
        'Your dashboard configuration does not allow login with Microsoft'
      )
    } else if (clearErrorString === 'User not found') {
      setMicrosoftLoginError(
        'A user with this Microsoft account was not found in the system'
      )
    } else {
      setMicrosoftLoginError(
        `An error occurred while logging in with Microsoft: ${errorString}`
      )
    }
  }

  return (
    <div className={styles.container}>
      <LoginWithGoogleButton
        onSuccess={loginToDashboard}
        onError={handleGoogleLoginError}
      />
      <LoginWithMicrosoftButton
        onSuccess={loginToDashboard}
        onError={handleMicrosoftLoginError}
      />
    </div>
  )
}

export default LoginButtons
